import { render, staticRenderFns } from "./rizhao.vue?vue&type=template&id=f360c0be&scoped=true"
import script from "./rizhao.vue?vue&type=script&lang=js"
export * from "./rizhao.vue?vue&type=script&lang=js"
import style0 from "./rizhao.vue?vue&type=style&index=0&id=f360c0be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f360c0be",
  null
  
)

export default component.exports